import { Button } from "common/components/ui/Button";
import { DialogFooter, DialogHeader } from "common/components/ui/Dialog";
import { DrawerFooter, DrawerHeader } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useMembersMutations from "../../datahooks/useMembersMutations";

interface RevokeMemberProps {
  inviteToken: string;
  onBack: () => void;
}

export default function RevokeInvite({
  inviteToken,
  onBack,
}: RevokeMemberProps) {
  const isDesktop = useTwBreakpoint("lg");

  const { revokeInvite, isRevokingInvite } = useMembersMutations();

  function onRevokeInvite() {
    revokeInvite({ inviteToken }).then(onBack);
  }
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <>
      <Header
        title="Revoke invite?"
        subtitle="This email will no longer be able to join your workspace"
      />

      <Footer className="items-center justify-end">
        <Button
          variant="secondary-black"
          disabled={isRevokingInvite}
          onClick={onBack}
        >
          Cancel
        </Button>

        <Button
          variant="outline-danger"
          isLoading={isRevokingInvite}
          onClick={onRevokeInvite}
        >
          Revoke invite
        </Button>
      </Footer>
    </>
  );
}
